<template>
  <div class="footer-audit">
    <div class="container">
      <div>
        <a href="https://www.uni-hamburg.de/en/uhh/kontakt-service.html">
          Address
        </a>
      </div>
      <div>
        <a href="https://www.uni-hamburg.de/en/uhh/kontakt-service/anfahrt.html">
          Map and directions
        </a>
      </div>
      <p class="copyright">
        © 2019 Universität Hamburg. All rights reserved
      </p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FooterAudit',
};
</script>

<style scoped>
.footer-audit {
  background: #3b515c;
  color: white;
  min-height: 149px;
  padding: 68px 20px 130px 20px;
  font-size: 16px;
}

.container {
  max-width: 1258px;
}

.container a {
  color: white;
  text-decoration: none;
}

.container a:hover {
  text-decoration: underline;
}

.copyright {
  margin-top: 70px;
}
</style>
